import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26272013"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "f10" }
const _hoisted_2 = { class: "hashwrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查看更多 ")
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 曾用名: ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footAffirms" }, " 免责声明： 本页面涉及的任何内容及操作仅均来源于第三方，与本平台无关，仅供您参考与学习观摩，该等内容不构成对任何金融产品的购买、抛售或持有的建议，不作为您做出任何投资的依据，您应自主投资决策，自行承担投资风险与损失，投资有风险，入市须谨慎！ ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navatop = _resolveComponent("Navatop")!
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["f10wrapper", _ctx.theme])
  }, [
    _createElementVNode("div", {
      class: "wrapper",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollhashwrapper && _ctx.scrollhashwrapper(...args)))
    }, [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_component_a_affix, {
          "offset-top": 0,
          target: _ctx.containerRef
        }, {
          default: _withCtx(() => [
            (_ctx.token)
              ? (_openBlock(), _createBlock(_component_Navatop, {
                  key: 0,
                  type: "us",
                  ref: "navatop",
                  onSetnav: _ctx.setnav,
                  theme: _ctx.theme,
                  activekey: _ctx.activekey,
                  token: _ctx.token,
                  onGetPageData: _ctx.getPageData,
                  onCurrentshares: _ctx.currentshares,
                  onIsopen: _ctx.setisopen
                }, null, 8, ["onSetnav", "theme", "activekey", "token", "onGetPageData", "onCurrentshares", "onIsopen"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["target"]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (item, i) => {
            return (_openBlock(), _createBlock(_component_a_card, {
              id: item.key,
              key: 'topnav' + i,
              size: "small",
              bordered: false
            }, _createSlots({
              title: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.cardtitleimg,
                  alt: ""
                }, null, 8, _hoisted_3),
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.key), {
                    pageSourceData: _ctx.pageSourceData,
                    theme: _ctx.theme,
                    currentsharesData: _ctx.currentsharesData,
                    itemdata: item,
                    token: _ctx.token,
                    onGetPubDate: _ctx.getPubDate
                  }, null, 40, ["pageSourceData", "theme", "currentsharesData", "itemdata", "token", "onGetPubDate"]))
                ], 1024)),
                (item.key == 'gsgy' && _ctx.pageSourceData.nameStr)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.theme === 'dark' ? 'nameStr' : 'nameStr_')
                    }, [
                      _hoisted_7,
                      _createElementVNode("span", null, _toDisplayString(_ctx.pageSourceData.nameStr), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (item.seemore)
                ? {
                    name: "extra",
                    fn: _withCtx(() => [
                      (item.seemore === 'seemore')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "seemore",
                            onClick: ($event: any) => (_ctx.seemore(item))
                          }, [
                            _hoisted_5,
                            _createVNode(_component_RightOutlined)
                          ], 8, _hoisted_4))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "seemore",
                            onClick: ($event: any) => (_ctx.seemoreDetail(item))
                          }, [
                            _createTextVNode(_toDisplayString(item.seemoredesc ? item.seemoredesc :
                item.title + '详情') + " ", 1),
                            _createVNode(_component_RightOutlined)
                          ], 8, _hoisted_6))
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["id"]))
          }), 128)),
          _hoisted_8
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_a_back_top, {
          target: _ctx.target,
          key: _ctx.key
        }, null, 8, ["target"])), [
          [_vShow, _ctx.showbacktop]
        ])
      ])
    ], 32),
    _createVNode(_component_Modal)
  ], 2))
}